export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'security-news',
    name: '安全资讯',
    description: '最新网络安全动态、行业新闻与风险预警',
    icon: 'ri-shield-check-line',
    articleCount: 12,
  },
  {
    id: 'cat-2',
    slug: 'version-guide',
    name: '版本辨别',
    description: '官方版本与虚假版本的识别方法',
    icon: 'ri-git-branch-line',
    articleCount: 8,
  },
  {
    id: 'cat-3',
    slug: 'usage-guide',
    name: '使用说明',
    description: '正确、安全的使用操作指南',
    icon: 'ri-book-open-line',
    articleCount: 10,
  },
  {
    id: 'cat-4',
    slug: 'privacy-protection',
    name: '隐私保护',
    description: '个人信息保护、数据安全与隐私防护',
    icon: 'ri-lock-line',
    articleCount: 9,
  },
  {
    id: 'cat-5',
    slug: 'malware-prevention',
    name: '恶意下载防范',
    description: '识别钓鱼链接、虚假安装包与病毒防护',
    icon: 'ri-virus-line',
    articleCount: 7,
  },
  {
    id: 'cat-6',
    slug: 'legal-compliance',
    name: '法律合规',
    description: '相关法律法规解读与合规使用指引',
    icon: 'ri-scales-line',
    articleCount: 6,
  },
];